const LAT_INDEX_ASSET = 0;
const LNG_INDEX_ASSET = 1;
const LNG_INDEX_PROJECT = 0;
const LAT_INDEX_PROJECT = 1;
const isPlottable = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
// Asset telemetry reports [lat, lng], unlike the project record below.
export const assetLocationToLatLng = (location) => {
    if (!Array.isArray(location))
        return null;
    const lat = Number(location[LAT_INDEX_ASSET]);
    const lng = Number(location[LNG_INDEX_ASSET]);
    return isPlottable(lat, lng) ? { lat, lng } : null;
};
// The project search response stores its site pin as GeoJSON [lng, lat].
export const projectCoordinatesToLatLng = (coordinates) => {
    if (!Array.isArray(coordinates))
        return null;
    const lat = Number(coordinates[LAT_INDEX_PROJECT]);
    const lng = Number(coordinates[LNG_INDEX_PROJECT]);
    return isPlottable(lat, lng) ? { lat, lng } : null;
};
export const getSiteViewport = (points) => {
    if (points.length === 0)
        return null;
    const lats = points.map((point) => point.lat);
    const lngs = points.map((point) => point.lng);
    return {
        east: Math.max(...lngs),
        north: Math.max(...lats),
        south: Math.min(...lats),
        west: Math.min(...lngs)
    };
};
